import * as React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import SearchAutocomplete from '@components/SearchAutocomplete';

const styles = () => createStyles({});

const MapSearch: React.FC<WithStyles<typeof styles> & {
  location?: {
    latitude: number;
    longitude: number;
  };
}> = ({ location }) => (
  <SearchAutocomplete location={location} variant="compact" autoFocus={false} />
);

export default withStyles(styles)(MapSearch);
